/**
 * Circular dependency prevention:
 * - useBasket
 */

import events$ from '@/services/Events'

import useBasket from '@/hooks/useBasket'
import useI18n from '@/hooks/useI18n'

import { EVENT_LANGUAGE } from '@/config/events'

const { i18n } = useI18n()
const browserLanguage = document.documentElement.getAttribute('lang')?.toLowerCase()

// TODO: Check if this function should undergo changes
async function loadAideTranslation(language) {
  const messages = await import(`@/language/aide/aide.${language}.json`)
  const content = i18n.global.getLocaleMessage(language)
  content['aide'] = messages.default
  i18n.global.setLocaleMessage(language, content)
  return content
}

function setPageTitleAndDescription(meta) {
  if (!meta) {
    throw new Error('Missing param meta')
  }

  // check, if DVP-"app" is present
  if (document.querySelector('div[app-name=Configurator]')) {
    document.querySelector('title').innerText = [import.meta.env.VITE_PAGE_TITLE_PREFIX, meta.title]
      .filter(x => !!x)
      .join(' ')
    document.querySelector('meta[name=description]').content = meta.description
  }
}

async function updateTranslations({ locale = i18n.global.locale.value, isAide = false, hasChanged = false }) {
  const language = locale.toLowerCase()
  const { updateLanguage } = useBasket()
  const messages = await import(`@/language/content/content.${language}.json`).then(res => res.default)

  if (isAide) {
    const aideMessages = await import(`@/language/aide/aide.${language}.json`)
    messages['aide'] = aideMessages.default
  }

  // set locale and locale message
  i18n.global.setLocaleMessage(language, messages)
  i18n.global.locale.value = language

  updateHtmlPageData(language, i18n.global.tm)
  await updateLanguage(language)
  events$.emit(EVENT_LANGUAGE.LOADED, { language, hasChanged })
}

function updateHtmlPageData(locale, tm) {
  // update html language attribute
  document.documentElement.setAttribute('lang', locale)
  const meta = tm('meta')
  // check, if DVP-"app" is present
  if (document.querySelector('div[app-name=Configurator]')) {
    document.querySelector('title').innerText = [import.meta.env.VITE_PAGE_TITLE_PREFIX, meta.title]
      .filter(x => !!x)
      .join(' ')
    document.querySelector('meta[name=description]').content = meta.description
  }
}

export default function useTranslation() {
  return {
    browserLanguage,

    loadAideTranslation,
    setPageTitleAndDescription,
    updateTranslations,
  }
}
